import { Route } from '@angular/router';
import { InitialDataResolver } from '@sprint-expert-manager/app/app.resolvers';
import { AuthGuard } from '@sprint-expert-manager/app/core/auth/auth-guard.service';
import { LayoutComponent } from '@sprint-expert-manager/app/layout/layout.component';

// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [
  { path: '', pathMatch: 'full', redirectTo: 'home' },
  {
    path: '',
    component: LayoutComponent,
    data: {
      layout: 'empty',
    },
    children: [
      {
        path: 'home',
        loadChildren: () =>
          import('@sprint-expert-manager/app/pages/landing/home/home.routes'),
      },
    ],
  },
  {
    path: '',
    canActivate: [AuthGuard],
    component: LayoutComponent,
    data: {
      layout: 'empty',
    },
    children: [
      {
        path: 'on-boarding',
        loadChildren: () =>
          import(
            '@sprint-expert-manager/app/pages/expert-manager-on-boarding/expert-manager-on-boarding.routes'
          ),
      },
      {
        path: 'maintenance',
        loadChildren: () =>
          import(
            '@sprint-expert-manager/app/pages/single/expert-system-maintenance/expert-system-maintenance.routes'
          ),
      },
    ],
  },

  // Landing routes
  {
    path: '',
    canActivate: [AuthGuard],
    component: LayoutComponent,
    resolve: {
      initialData: InitialDataResolver,
    },
    children: [
      // {
      //   path: 'expert-console-list',
      //   loadChildren: () =>
      //     import(
      //       '@sprint-expert-manager/app/pages/expert-console-list/expert-console-list.routes'
      //     ),
      //   canActivate: [AuthGuard],
      //   data: {
      //     roles: [KeycloakUserRole.ExpertManager],
      //   },
      // },
      // {
      //   path: 'settings',
      //   loadChildren: () =>
      //     import(
      //       '@sprint-expert-manager/app/pages/expert-manager-settings/expert-manager-settings.routes'
      //     ),
      //   canActivate: [AuthGuard],
      //   data: {
      //     roles: [KeycloakUserRole.ExpertManager],
      //   },
      // },
      {
        path: 'not-found',
        pathMatch: 'full',
        loadChildren: () =>
          import(
            '@sprint-expert-manager/app/pages/single/error-not-found/error-not-found.routes'
          ),
      },
      {
        path: '**',
        redirectTo: 'not-found',
      },
    ],
  },
];
